module.exports = __webpack_public_path__ + "img/order-done.df183325.svg";